import {Component, Input, OnInit} from '@angular/core';
import {Observable, of} from 'rxjs';
import {FullUser} from '../../../model';
import {Store} from '@ngrx/store';
import {AppState} from '../../../../app.store';
import {ActivatedRoute} from '@angular/router';
import {LoadUser} from '../../../state/user.actions';
import {UserService} from '../../../services';

@Component({
  selector: 'app-portfolio-base',
  templateUrl: './portfolio-base.component.html',
  styleUrls: ['./portfolio-base.component.css']
})
export class PortfolioBaseComponent implements OnInit {
  @Input() public user: FullUser;
  user$: Observable<FullUser>;
  constructor(private store: Store<AppState>, private userService: UserService,
              private route: ActivatedRoute) { }

  ngOnInit() {
    const userId = this.route.snapshot.paramMap.get('userId');
    if (this.user) {
      this.user$ = of(this.user);
    } else {
      this.store.dispatch(new LoadUser(userId));
      this.user$ = this.store.select(state => state.user.users[userId]);
    }
  }
}
